<template>
  <v-dialog
    v-model="show"
    max-width="800"
    persistent
  >
    <v-card flat>
      <v-toolbar
        color="primary"
        dark
        flat
      >
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          @click="close"
          icon
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="modal-content">
        <div
          v-for="(period, index) in periods"
          :key="index"
          class="period-item"
        >
          <div class="period-header">
            Período: {{ formatPeriodDate(period.startDate) }} à {{ formatPeriodDate(period.endDate) }}
          </div>
          <div class="period-content">
            <div class="period-metric">
              <span class="metric-label">Quantidade Escoado:</span>
              <span class="metric-value">{{ formatNumber(period.quantitySellout || 0) }}</span>
            </div>
            <div class="period-metric">
              <span class="metric-label">SDZ Aceleradores (Bruto):</span>
              <span class="metric-value">{{ formatCurrency(period.acceleratorGross || 0) }}</span>
            </div>
            <div class="period-metric">
              <span class="metric-label">SDZ Aceleradores (Líquido):</span>
              <span class="metric-value">{{ formatCurrency(period.acceleratorNet || 0) }}</span>
            </div>
            <div class="period-metric">
              <span class="metric-label">Seedz (Bruto):</span>
              <span class="metric-value">{{ formatCurrency(period.seedzGross || 0) }}</span>
            </div>
            <div class="period-metric">
              <span class="metric-label">Seedz (Líquido):</span>
              <span class="metric-value">{{ formatCurrency(period.seedzNet || 0) }}</span>
            </div>
            <div class="period-metric">
              <span class="metric-label">Diferença:</span>
              <span class="metric-value">{{ formatCurrency(period.difference || 0) }}</span>
            </div>
            <div class="period-metric">
              <span class="metric-label">Seedz Pago:</span>
              <span class="metric-value">{{ formatCurrency(period.seedzPaid || 0) }}</span>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ParticipantPeriodsModal',
  data: () => ({
    show: false,
    title: '',
    periods: []
  }),
  methods: {
    open({ participantName, periods }) {
      this.title = participantName || 'Participante'
      this.periods = periods || []
      this.show = true
    },
    close() {
      this.show = false
      this.periods = []
      this.title = ''
    },
    formatPeriodDate(date) {
      if (!date) return '-'
      return this.$date(date)
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return '0'
      return this.$currencyFormat(value)
    },
    formatNumber(value) {
      if (value === null || value === undefined) return '0'
      return value.toString()
    }
  }
}
</script>

<style lang="stylus" scoped>
.modal-content {
  background-color: #ffffff;
  padding: 24px;
}

.period-item {
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-bottom: 16px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

  &:last-child {
    margin-bottom: 0;
  }
}

.period-header {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  color: #001648;
  background-color: #DEE7E6;
  padding: 12px 16px;
  border-radius: 4px 4px 0 0;
}

.period-content {
  padding: 16px;
  background-color: #ffffff;
}

.period-metric {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);

  &:last-child {
    border-bottom: none;
  }
}

.metric-label {
  font-size: 14px;
  color: #424242;
  font-weight: 400;
  flex: 1;
}

.metric-value {
  font-size: 14px;
  color: #424242;
  font-weight: 500;
  text-align: right;
  min-width: 100px;
}
</style>

